import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="dark-footer-content">
        <div className="footer-section">
          <h3 className="footer-title">{businessInfo.name}</h3>
          <p className="footer-text">
            Professional mobile car stereo installation serving Metro Atlanta.
            We bring expert audio installation directly to your location.
          </p>
          <div className="footer-rating">
            <span className="rating-stars">★★★★★</span>
            <span className="rating-text">{businessInfo.rating} Google Rating</span>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/services" className="footer-link">Services</Link></li>
            <li><Link to="/reviews" className="footer-link">Reviews</Link></li>
            <li><Link to="/about" className="footer-link">About Us</Link></li>
            <li><Link to="/contact" className="footer-link">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contact Info</h4>
          <div className="footer-contact">
            <div className="contact-item">
              <Phone size={18} />
              <a href={`tel:${businessInfo.phone}`} className="contact-link">
                {businessInfo.phone}
              </a>
            </div>
            <div className="contact-item">
              <MapPin size={18} />
              <span>{businessInfo.location}</span>
            </div>
            <div className="contact-item">
              <Clock size={18} />
              <span>{businessInfo.hours}</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Service Area</h4>
          <ul className="footer-service-area">
            {businessInfo.serviceArea.map((area, index) => (
              <li key={index}>{area}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {businessInfo.name}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;